import React from "react";
import { useNavigate } from "react-router-dom";
// import PageHeader from "../../OtherComponents/PageHeader";

const UserScreen = () => {
  const navigate = useNavigate();

  const cardData = [
    {
      title: "Book Appointment",
      icon: "pi-calendar",
      route: "/booking-doc-list",
    },
    { title: "Patient Details", icon: "pi-user", route: "/user-details" },
    {
      title: "Appointment History",
      icon: "pi-calendar-times",
      route: "/appointments",
    },
    {
      title: "Upcoming Appointment",
      icon: "pi-calendar-plus",
      route: "/upcoming-appointments",
    },
    { title: "Reports", icon: "pi-file", route: "/reports" },
    { title: "Medical Record", icon: "pi-book", route: "/patient-records" },
    { title: "Billing", icon: "pi-wallet", route: "/billing-history" },
    { title: "My Documents", icon: "pi-folder", route: "/documents" },
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <div style={styles.wrapper}>
      {/* <PageHeader title="User Dashboard"/> */}
      <div style={styles.header}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
          alt="user avatar"
          style={styles.avatar}
        />
        <h2 style={styles.title}>Welcome, Patient 👋</h2>
        <p style={styles.subtitle}>Manage your health in a click!</p>
      </div>

      <div style={styles.grid}>
        {cardData.map((card, idx) => (
          <div
            key={idx}
            onClick={() => handleCardClick(card.route)}
            className="user-card"
            style={{
              ...styles.card,
              background: `linear-gradient(135deg, ${
                cardColors[idx % cardColors.length]
              }CC, #ffffff44)`,
            }}
          >
            <i className={`pi ${card.icon}`} style={styles.icon}></i>
            <div style={styles.cardText}>{card.title}</div>
          </div>
        ))}
      </div>

      {/* Inline style for transitions */}
      <style>{`
        .user-card {
          transition: all 0.3s ease;
        }

        .user-card:hover {
          transform: scale(1.05);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
          filter: brightness(1.08);
        }
      `}</style>
    </div>
  );
};

// Slightly darker pastel palette
const cardColors = [
  "#64b5f6",
  "#f06292",
  "#81c784",
  "#fff176",
  "#ba68c8",
  "#4dd0e1",
  "#ffb74d",
  "#9575cd",
];

const styles = {
  wrapper: {
    minHeight: "100vh",
    padding: "40px 50px",
    background: "linear-gradient(to right top, #f1f4f9, #d7dee7)",
    fontFamily: "'Segoe UI', sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
  },
  avatar: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    marginBottom: "15px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  },
  title: {
    fontSize: "26px",
    fontWeight: 700,
    color: "#1a1a2e",
    margin: 0,
  },
  subtitle: {
    fontSize: "15px",
    color: "#444",
    marginTop: "8px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "25px",
  },
  card: {
    padding: "30px 20px",
    borderRadius: "20px",
    textAlign: "center",
    color: "#1a1a2e",
    cursor: "pointer",
    backdropFilter: "blur(10px)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
  },
  icon: {
    fontSize: "28px",
    marginBottom: "12px",
    color: "#1a1a2e",
  },
  cardText: {
    fontSize: "16px",
    fontWeight: 500,
  },
};

export default UserScreen;
